// extracted by mini-css-extract-plugin
export default {"root":"IconCheckedBox_root__OK8Gg"};